<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
               style="color: #ee7a18; font-size: 36px; padding: 20px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
        that:this,
        activeName: 'AL271',
        XJList: [
        {
          name: "AL271",
          textName: '安仑AL271特种炭黑',
          textName_en: 'AL271 SPECIAL CARBON BLACK',
          description1: 'AL271是安仑化工推出的一款平均粒径27nm左右的普通色素炉法炭黑（RCF），主要用于通用塑料的着色和色浆、油墨等液体应用。',
          description1_en: 'AL271 is a regular colour furnace carbon black (RCF) launched by Anlun Chemical with an average primary particle size of 27nm, which is mainly used for coloring polyolefins and ink applications.',
          description2: '',
          description3: '',
          description4: '',
          compare1: '',
          compare2: '',
          compare3: '',
          compare4: '',
          remark1:'* 以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en:'The data above are typical test values intended as guidance only.',
          remark2: 'AL271产品具有适中的粒径、结构度和高纯净度，使用过程中具有以下优异性能：',
          remark2_en: 'AL271 with moderate particle size, structure and high purity provides excellent performance as below:',
          remark3: '良好的分散性和稀释性，有利于黑色母及下游制品的生产；',
          remark3_en: 'Good dispersibility and dilution, facilitating masterbatch production and downstream application;',
          remark4: '极低的杂质含量，有效减少挤出、注塑和吹塑制品的表面缺陷；',
          remark4_en: 'Extremely low impurity content, reducing surface defects of extruded and blow-molded products;',
          remark5: '挤出过滤压力低，延长挤出机滤网寿命，提高生产效率。',
          remark5_en: 'Low filtration pressure during extrusion, prolonging the life of filter screen and improving productivity.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2:'包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en:'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4:'包装：10kg PE袋/纸袋',
          pack4_en:'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL271-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL271-1-EN.jpg"),
          img2: require("../../assets/img/shuzhi/AL271-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL271-2-EN.jpg"),
        },
        {
          name: "AL272",
          textName: '安仑AL272特种炭黑',
          textName_en: 'AL272 SPECIAL CARBON BLACK',
          description1: 'AL272是安仑化工推出的一款平均粒径27nm左右的低结构普通色素炉法炭黑（RCF），主要用于通用塑料的着色和色浆、油墨等液体应用。',
          description1_en: 'AL272 is a low-structure regular colour furnace carbon black (RCF) launched by Anlun Chemical with an average primary particle size of 27nm, which is mainly used for coloring polyolefins and ink application.',
          description2: '',
          description3: '',
          description4: '',
          compare1: '',
          compare2: '',
          compare3: '',
          compare4: '',
          compare5: '',
          remark1:'*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en:'The data above are typical test values intended as guidance only.',
          remark2: '与AL271相比，AL272具有以下优异性能：',
          remark2_en: 'Compared with AL271, AL272 has the following application characteristics:',
          remark3: '高黑度，可减少炭黑用量，降低成本。',
          remark3_en: 'High blackness to reduce carbon black loading for cost saving;',
          remark4: '易润湿，可降低分散剂的用量，节约成本；',
          remark4_en: 'Easy wettability to low dispersant usage for cost saving;',
          remark5: '在同样添加量下，黑色母粒具有更高的熔融指数.',
          remark5_en: 'High melt flow rate under the same loading in masterbatch;',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2:'包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en:'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4:'包装：10kg PE袋/纸袋',
          pack4_en:'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL271-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL271-1-EN.jpg"),
          img2: require("../../assets/img/shuzhi/AL271-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL271-2-EN.jpg"),
        },
        {
          name: "AL273HS",
          textName: '安仑AL273HS特种炭黑',
          textName_en: 'AL273HS SPECIAL CARBON BLACK',
          description1: 'AL273HS是安仑化工推出的一款平均粒径23nm左右的高结构中色素炉法炭黑（MCF），主要用于塑料、油墨等的着色，特别适用是高端吹膜塑料制品。',
          description1_en: 'AL273HS is a high-structure medium colour furnace carbon black (MCF) launched by Anlun Chemical with an average primary particle size of 23nm, which is mainly used for coloring plastics and inks, especially high-end blowing film.',
          description2: '',
          description3: '',
          description4: '',
          compare1: '',
          compare2: '',
          compare3: '',
          compare4: '',
          compare5: '',
          compare6: '',
          remark1:'*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en:'* The data above are typical test values intended as guidance only.',
          remark2: '与AL271和AL272等普通色素炭黑（RCF）相比，AL273HS具有以下优异性能：',
          remark2_en: 'Compared with N220 and N330 carbon black, AL273HS has the following application characteristics:',
          remark3: '高黑度，可减少色母、色浆中的炭黑用量；',
          remark3_en: 'High blackness for finished product;',
          remark4: '高遮盖力，适用于塑料薄膜和胶印油墨等；',
          remark4_en: 'High covering power, suitable for plastic film and offset printing ink;',
          remark5: '更强的紫外吸收能力，赋予制品良好的耐候性。',
          remark5_en: 'High purity and dispersibility, longer life for filter screen of extruder and fewer crystal points of film blowing;',
          remark6: '更高的纯净度和分散性，延长塑料挤出机滤网寿命，提高生产效率。',
          remark6_en: 'High ultraviolet absorption capacity then good weather resistance in application.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 7.5kg/10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL273HS-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL273HS-1-EN.jpg"),
          img2: require("../../assets/img/shuzhi/AL273HS-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL273HS-2-EN.jpg"),
        },
        {
          name: "AL273LS",
          textName: '安仑AL273LS特种炭黑',
          textName_en: 'AL273LS SPECIAL CARBON BLACK',
          description1: 'AL273LS是安仑化工推出的一款平均粒径23nm左右的低结构中色素炉法炭黑（MCF），主要用于油墨、色浆及通用塑料的着色。',
          description1_en: 'AL273LS is a low-structure medium colour furnace carbon black (MCF) launched by Anlun Chemical with an average particle size of about 23nm, which is mainly used for coloring polyolefins, ink & coat.',
          description2: '',
          description3: '',
          description4: '',
          compare1: '',
          compare2: '',
          compare3: '',
          compare4: '',
          compare5: '',
          compare6: '',
          remark1: '*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en: 'The data above are typical test values intended as guidance only.',
          remark2: '与AL271，AL272等普通色素炭黑（RCF）相比，AL273LS具有以下优异性能：',
          remark2_en: 'Compared with AL271, AL272, AL273HS has the following application characteristics:',
          remark3: '高黑度，可减少炭黑用量降低成本；',
          remark3_en: 'High blackness to reduce carbon black loading for cost saving;',
          remark4: '高流动性，色母熔融指数高，油墨涂料的黏度低；',
          remark4_en: 'Good fluidity: high melt index of color masterbatch and low viscosity of ink & coating;',
          remark5: '易润湿，可降低分散剂的用量，节约成本；',
          remark5_en: 'Easy wetability to reduce dispersant loading for cost saving;',
          remark6: '强紫外吸收能力，赋予下游制品良好的耐候性。',
          remark6_en: 'Strong UV absorption then excellent weather resistance for finished product;',
          remark7: '高纯净度，延长塑料挤出机滤网寿命，提高生产效率。',
          remark7_en: 'High purity for prolonging the life of filter screen then improving productivity.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 7.5kg/10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL273LS-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL273LS-1-EN.jpg"),
          img2: require("../../assets/img/shuzhi/AL273LS-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL273LS-2-EN.jpg"),
        },
        {
          name: "AL281",
          textName: '安仑AL281特种炭黑',
          textName_en: 'AL281 SPECIAL CARBON BLACK',
          description1: 'AL281是安仑化工推出的一款平均粒径20nm左右的中色素炉法炭黑（MCF），主要用于工程塑料着色和水性油墨、色浆等液体应用。',
          description1_en: 'AL281 is a medium colour furnace carbon black (MCF) launched by Anlun Chemical with an average primary particle size of 18nm, which is mainly used for coloring engineering plastics, water-based inks and coatings.',
          description2: '',
          description3: '',
          description4: '',
          compare1: '',
          compare2: '',
          compare3: '',
          compare4: '',
          compare5: '',
          compare6: '',
          remark1:'*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en:'* The data above are typical test values intended as guidance only.',
          remark2: 'AL281是小粒径、低结构特种炭黑，与AL27X系列产品相比，在工程塑料着色和液体应用中具有以下优异性能：',
          remark2_en: 'AL281 with small particle size and low structure is specially designed for engineering plastics, which has the following application characteristics:',
          remark3: '高黑度和高光泽，可减少炭黑用量降低成本；',
          remark3_en: 'Excellent Jeness and glossiness to low carbon black loading for cost saving;',
          remark4: '加工使用中易润湿，可降低分散剂的用量；',
          remark4_en: 'Easy wettability to low dispersant usage for cost saving;',
          remark5: '强的紫外吸收能力，赋予下游制品良好的耐候性；',
          remark5_en: 'Strong UV absorption by small particle size to provide good weather resistance;',
          remark6: '黑色母粒在工程塑料中具有较好的稀释性；',
          remark6_en: 'Easy dilute of black masterbatch in engineering plastics;',
          remark7: '较高的蓝相。',
          remark7_en: 'Higher blue tone.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2:'包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en:'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4:'包装：10kg PE袋/纸袋',
          pack4_en:'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL281-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL281-1-EN.jpg"),
          img2: require("../../assets/img/shuzhi/AL281-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL281-2-EN.jpg"),
        },
        {
          name: "AL291",
          textName: '安仑AL291特种炭黑',
          textName_en: 'AL291 SPECIAL CARBON BLACK',
          description1: 'AL291是安仑化工推出的一款平均粒径15nm左右的高色素炉法炭黑（HCF），主要用于工程塑料和色浆、油墨等液体的着色。',
          description1_en: 'AL291 is a high colour furnace carbon black (HCF) launched by Anlun Chemical with an average primary particle size of 15nm, which is mainly used for coloring engineering plastics, color pastes and coatings.',
          description2: '',
          description3: '',
          description4: '',
          compare1: ' ',
          compare1_en: 'Compared with regular colour furnace black (carbon black AL272 and medium colour carbon black AL281, the comprehensive performance of AL291 is shown as below figure:',
          compare2: '',
          compare3: '',
          compare4: '',
          compare5: '',
          compare6: '',
          remark1:'*以上典型数据仅供参考，配方、工艺等不同或有差异，需依实际情况为准。',
          remark1_en:'* The data above are typical test values intended as guidance only.',
          remark2: '与中色素炭黑（MCF）AL281相比，AL291具有相同的结构但更小的粒径，为下游产品带来以下优异性能：',
          remark2_en: 'Compared with medium colour furnace black (MCF) AL281, AL291 with small particle size and low structure has the following application characteristics:',
          remark3: '极佳的黑度和光泽度；',
          remark3_en: 'Excellent Jeness and glossiness;',
          remark4: '极佳的紫外吸收能力；',
          remark4_en: 'Excellent UV absorption capacity;',
          remark5: '更高的蓝相。',
          remark5_en: ' Higher blue tone.',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2:' 包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en:' Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4:' 包装：7.5kg/10kg PE袋/纸袋',
          pack4_en:' Packaging: 7.5kg/10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/AL291-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/AL291-1.jpg"),
          img2: require("../../assets/img/shuzhi/AL291-2.jpg"),
          img2_en: require("../../assets/img/shuzhi/AL291-2.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
    color: #ee7a18 !important;
    cursor: pointer !important;
}
::v-deep #tab-AL271 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL272 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL273HS {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL273LS {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL281 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
::v-deep #tab-AL291 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
</style>